export function isAdminV2InternalEntryActionHref(href: string) {
  return href.startsWith('/') && !href.startsWith('//');
}
